module.exports = __webpack_public_path__ + "img/img.41e3c564.png";